var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
import { ifNotProp } from 'styled-tools';
import Button from '../Button/Button';
export var ButtonIcon = styled(Button)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: ", ";\n  justify-content: center;\n  align-items: center;\n\n  ", "\n\n  padding: 0 15px;\n  letter-spacing: 0;\n\n  ", "\n"], ["\n  display: flex;\n  flex-direction: ", ";\n  justify-content: center;\n  align-items: center;\n\n  ", "\n\n  padding: 0 15px;\n  letter-spacing: 0;\n\n  ", "\n"])), function (_a) {
    var iconPosition = _a.iconPosition;
    return iconPosition === 'left' ? 'row-reverse' : 'row';
}, ifNotProp('hasText', function () { return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      min-height: 44px;\n      min-width: 44px;\n    "], ["\n      min-height: 44px;\n      min-width: 44px;\n    "]))); }), function (_a) {
    var isRounded = _a.isRounded;
    return isRounded && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      border-radius: 32px;\n    "], ["\n      border-radius: 32px;\n    "])));
});
export var Text = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var iconPosition = _a.iconPosition;
    return iconPosition === 'left' ? 'margin-left: 8px;' : 'margin-right: 8px;';
});
export default ButtonIcon;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
